// extracted by mini-css-extract-plugin
export default {"container":"L2-z","list":"M2-z"};